<template>
    <div class="card-body">
        <div class="text-center mb-3">
            <i class="icon-user icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"></i>
            <h5 class="mb-0">{{ $t('auth.authentication.title') }}</h5>
            <span class="d-block text-muted">{{ $t('auth.authentication.description') }}</span>
        </div>

        <form @submit.prevent="login">
            <FormGroup :label="$t('auth.fields.email')">
                <Input type="text" :placeholder="$t('auth.fields.email')" v-model="email"/>
            </FormGroup>

            <FormGroup :label="$t('auth.fields.password')">
                <Input type="password" :placeholder="$t('auth.fields.password')" v-model="password"/>
            </FormGroup>

            <div style="display: flex; position: relative; margin-bottom: 10px;">
                <Checkbox v-model="remember" style="padding-top: 8px"/>
                <label style="display: flex; padding-left: 15px; padding-top: 8px">
                    {{ $t('auth.authentication.remember') }} |
                    <a href="#" @click.prevent="$emit('forgot-password')" style="margin-left: 5px">{{ $t('auth.authentication.reset_password') }}</a>
                </label>
            </div>

            <p>
                {{ $t('auth.authentication.no_account') }}
                <router-link :to="{ name: 'RegistrationPage', query: $route.query }">{{ $t('auth.authentication.register_now') }}</router-link>
            </p>

            <div class="btn-group-justified">
                <Button size="sm" type="submit" color="primary">{{ $t('auth.buttons.login') }}<i class="icon-circle-right2 ml-2"></i></Button>
            </div>
        </form>
    </div>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Checkbox from "../../../../../components/new/form/checkbox/AppCheckbox.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import { httpClient } from "../../../../../services/HttpClient";
import { generateUrl } from "../../../../../utils";

export default {
    name: "LoginCard",
    components: {
        FormGroup,
        Input,
        Checkbox,
        Button,
    },
    emits: ['forgot-password'],
    data() {
        return {
            email: null,
            password: null,
            remember: false,
        }
    },
    methods: {
        async login() {
            let response = await httpClient.post('/authentication/login', {
                email: this.email,
                password: this.password,
                remember: this.remember,
                fs_lead_id: this.$route.query.fs_lead_id ?? null,
            });

            if (response?.data?.data) {
                window.location.replace(generateUrl('app/home'));
            }
        },
    },
}
</script>
